import { arrayOf, bool, func } from 'prop-types';
import React from 'react';

import { atgCalendarHighlight } from 'calendar/proptypes';
import ComponentLoadingSection from 'shared/components/ComponentLoadingSection';

import AtgHighlightItem from './AtgHighlightItem';

const AtgHighlights = ({ highlights, onItemClick, loading }) => (
  <ComponentLoadingSection loading={loading}>
    <ul>
      {highlights.map((highLight, idx) => (
        <AtgHighlightItem
          key={idx}
          highLight={highLight}
          onClick={onItemClick}
        />
      ))}
    </ul>
  </ComponentLoadingSection>
);

AtgHighlights.propTypes = {
  highlights: arrayOf(atgCalendarHighlight).isRequired,
  loading: bool.isRequired,
  onItemClick: func.isRequired,
};

export default AtgHighlights;
